import { MinusIcon, PlusIcon } from "lucide-react";



export default function FilterItem({
  label,
  keyName,
  isOpen = false,
  onClick,
  options = [],
  selectedValue,
  onSelect,
}: {
  label: string;
  keyName: string;
  isOpen?: boolean;
  selectedValue?: string;
  onClick?: () => void;
  options?: string[];
  onSelect?: (key: string, value: string) => void;
}) {
  const hasChildren = options.length > 0;

  return (
    <div className="mb-3">
      <div
        className="flex items-center justify-between border-b border-[#B4B4B466] pb-2 cursor-pointer"
        onClick={() => {
          if (!hasChildren) onSelect?.(keyName, label);
          else onClick?.();
        }}
      >
        <span className="font-medium">
          {label} {selectedValue ? `: ${selectedValue}` : ""}
        </span>

        {hasChildren &&
          (isOpen ? (
            <MinusIcon size={18} className="text-black" />
          ) : (
            <PlusIcon size={18} className="text-black" />
          ))}
      </div>

      {hasChildren && isOpen && (
        <div className="mt-2 pl-2 space-y-1">
          {options.map((opt) => (
            <div
              key={opt}
              className={`cursor-pointer hover:text-primary ${
                selectedValue === opt ? "font-semibold text-primary" : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                onSelect?.(keyName, opt);
              }}
            >
              • {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};